import { defineStore } from 'pinia'

// 访问过的话题（本地记录），最近访问在前。用于首页分类 tab。
const KEY = 'crirp_visited_topics'
const CAP = 12   // 记录上限，防止无限增长

function load() {
  try {
    const arr = JSON.parse(localStorage.getItem(KEY) || '[]')
    if (!Array.isArray(arr)) return []
    // 清理历史脏记录：必须有 id；slug 缺失（旧版本未持久化）的用 id 兜底，
    // 否则首页 tab 点击会导航到 /t/undefined → 触发 /api/topic/undefined「话题不存在」
    return arr
      .filter((t) => t && Number(t.id))
      .map((t) => ({ ...t, id: Number(t.id), slug: t.slug || String(t.id) }))
  } catch (e) { return [] }
}

export const useHistoryStore = defineStore('history', {
  state: () => ({
    visited: load(),   // [{ id, slug, title, icon }]
  }),
  actions: {
    // 记录一次访问：去重后置顶（LRU），按上限截断
    record(topic) {
      if (!topic || !topic.id) return
      const id = Number(topic.id)
      const next = this.visited.filter((t) => Number(t.id) !== id)
      next.unshift({ id, slug: topic.slug, title: topic.title, icon: topic.icon || '' })
      if (next.length > CAP) next.length = CAP
      this.visited = next
      this._save()
    },
    // 移除一条访问记录（分类 tab 右上角 x）
    remove(id) {
      id = Number(id)
      this.visited = this.visited.filter((t) => Number(t.id) !== id)
      this._save()
    },
    _save() {
      try { localStorage.setItem(KEY, JSON.stringify(this.visited)) } catch (e) { /* ignore */ }
    },
  },
})
